import type { ConversationScope } from '../../components/GuardianProvider';

/**
 * Cache keys for a conversation's messages.
 *
 * The scope belongs in this key and in no other: `useChatHistory` builds the sidebar list by
 * *scanning* the `['chat']` prefix, so a dashboard analysis has to live under its own root to
 * stay out of it — no filtering, no marker on the id. The conversation's other entries
 * (`chatMetadata`, `chatTitle`, `panels`, `dashboardAgentState`) are only ever read by id,
 * never scanned, and ids are unique: scoping them too would buy nothing.
 */
export const CHAT_MESSAGES_ROOT = 'chat';
export const DASHBOARD_MESSAGES_ROOT = 'dashboardChat';

/** Every root holding conversation messages — for anything that must cover them all. */
export const ALL_MESSAGES_ROOTS = [CHAT_MESSAGES_ROOT, DASHBOARD_MESSAGES_ROOT] as const;

export const messagesRoot = (scope: ConversationScope): string =>
  scope === 'dashboard' ? DASHBOARD_MESSAGES_ROOT : CHAT_MESSAGES_ROOT;

/** The messages of one conversation, under the root its scope belongs to. */
export const messagesKey = (scope: ConversationScope, conversationId: string) =>
  [messagesRoot(scope), conversationId] as const;
